import { getSessionToken } from "@shopify/app-bridge-utils";

const SESSION_TOKEN_REFRESH_INTERVAL = 2000; // Request a new token every 2s

// Configure Turbo for iframe environment
document.addEventListener("turbo:before-fetch-request", function (event) {
  if (window.sessionToken) {
    event.detail.fetchOptions.headers["Authorization"] = "Bearer " + window.sessionToken;
  }
});

document.addEventListener("turbo:render", function () {
  document.querySelectorAll("form, a[data-method=delete]").forEach(function(element) {
    element.addEventListener("ajax:beforeSend", function (event) {
      if (window.sessionToken) {
        const xhr = event.detail[0];
        xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);
      }
    });
  });
});

// Handle iframe-specific Turbo behavior
document.addEventListener("turbo:before-visit", function (event) {
  // Check if we're in an iframe
  if (window.self !== window.top) {
    // Prevent Turbo from navigating if it would break the iframe
    const url = new URL(event.detail.url);
    const currentUrl = new URL(window.location.href);
    
    // If trying to navigate to a different domain, prevent it
    if (url.origin !== currentUrl.origin) {
      event.preventDefault();
      // Optionally, open in parent window instead
      window.top.location.href = event.detail.url;
    }
  }
});

// Handle form submissions in iframe context
document.addEventListener("turbo:submit-start", function (event) {
  if (window.self !== window.top) {
    // Ensure forms work properly in iframe
    const form = event.target;
    if (form.target === "_top" || form.target === "_parent") {
      // Let the form submit normally to break out of iframe
      return;
    }
    // Otherwise, ensure it stays in the iframe
    form.target = "_self";
  }
});

// Wait for DOM to be ready before initializing
function initializeShopifyApp() {
  var initElement = document.getElementById("shopify-app-init");
  if (!initElement) {
    setTimeout(initializeShopifyApp, 100);
    return;
  }
  
  var data = initElement.dataset;
  
  var AppBridge = window["app-bridge"];
  if (!AppBridge) {
    setTimeout(initializeShopifyApp, 100);
    return;
  }
  
  var createApp = AppBridge.default;
  window.app = createApp({
    apiKey: data.apiKey,
    host: data.host,
  });

  var actions = AppBridge.actions;
  var TitleBar = actions.TitleBar;
  TitleBar.create(app, {
    title: data.page,
  });

  // Try to get a session token, but don't block redirect indefinitely
  attemptTokenThenRedirect(app);

  // Helper functions
  function redirectThroughTurbo(isInitialRedirect = false) {
    var data = document.getElementById("shopify-app-init").dataset;
    var validLoadPath = data && data.loadPath;
    var shouldRedirect = false;
    
    // Get current path to compare
    var currentPath = window.location.pathname;

    switch(isInitialRedirect) {
      case true:
        // On initial load, redirect if we have a load path and we're not already there
        shouldRedirect = validLoadPath && currentPath !== data.loadPath;
        break;
      case false:
        // On subsequent loads, redirect if we have a load path and we're not already there
        shouldRedirect = validLoadPath && currentPath !== data.loadPath;
        break;
    }
    
    if (shouldRedirect) {
      if (window.Turbo) {
        Turbo.visit(data.loadPath);
      } else {
        window.location.href = data.loadPath;
      }
    }
  }

  async function retrieveToken(app) {
    try {
      window.sessionToken = await getSessionToken(app);
    } catch (e) {
      // swallow; we'll retry
    }
  }

  function keepRetrievingToken(app) {
    setInterval(() => {
      retrieveToken(app);
    }, SESSION_TOKEN_REFRESH_INTERVAL);
  }

  async function attemptTokenThenRedirect(app) {
    // Race token retrieval against a short timeout so UI doesn't hang on splash
    const timeoutMs = 1500;
    await Promise.race([
      (async () => { await retrieveToken(app); })(),
      new Promise((resolve) => setTimeout(resolve, timeoutMs)),
    ]);

    // Begin background refresh regardless of outcome
    keepRetrievingToken(app);

    // Redirect to requested path
    var isInitialRedirect = true;
    redirectThroughTurbo(isInitialRedirect);

    document.addEventListener("turbo:load", function () {
      redirectThroughTurbo();
    });
  }
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeShopifyApp);
} else {
  initializeShopifyApp();
}
